import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { initialize } from 'utils/initialize';
import initializeUserContext from 'utils/initializeUserContext';
import { get_ } from 'sf-modules';
import { gql } from '@yema/commerce/APIClient';
import { getCatalogCategories, getMenus } from 'functions/fnRequestAPIs/fnMenus';
import YDSCatalog from 'components/catalog/YDSCatalog';
import NotFoundLayout from 'layouts/NotFound.layout';
import PageLayout from 'layouts/Page.layout';
import { PATH_CATEGORY } from 'constants/paths';
import { useDispatch, useSelector } from '@yema/commerce/StoreClient';

const GET_FACETS = gql`
    query ProductFacets {
        facets
    }
`;

// @TODO Ludo: hardcoded fix until solution is found
const transformCategoryPath = (path) => {
    switch (path) {
        case '/c/comida':
            return '/sc/catalogo-comida';
        case '/c/cuidado-personal':
            return '/sc/catalogo-cuidado-personal';
        case '/c/bienestar':
            return '/sc/catalogo-bienestar';
        case '/c/bebes-y-ninos':
            return '/sc/catalogo-bebes-y-ninos';
        case '/c/hogar':
            return '/sc/catalogo-hogar';
        case '/c/mascotas':
            return '/sc/catalogo-mascotas';
        default:
            return path;
    }
};

/** SET CATALOG CATEGORIES MENU */
const getCategoryContent = async (category, apolloClient) => {
    let path = transformCategoryPath(category);
    const menuCategories = await getCatalogCategories(apolloClient);

    let selectedCategory = null;

    function findSelectedInList(list) {
        let listArray = Array.isArray(list) ? list : [list];
        listArray.find((currentItem) => {
            let children = currentItem.categories
                ? currentItem.categories
                : currentItem.subcategories
                ? currentItem.subcategories
                : [];
            if (currentItem.link === path) selectedCategory = currentItem;
            else return findSelectedInList(children);
        });
    }

    if (menuCategories) findSelectedInList(menuCategories);

    // Temp hardcode since we manually added "Pasillo > " in Wagtail for main categories
    if (
        selectedCategory &&
        selectedCategory.algolia &&
        selectedCategory.algolia.startsWith('Pasillos > ')
    )
        selectedCategory.algolia = selectedCategory.algolia.replace('Pasillos > ', '');

    return selectedCategory;
};

const Catalog = ({
    staticContent,
    selectedCategory,
    currentNavCategory,
    currentPage,
    facetsKeys,
}) => {
    const router = useRouter();
    const authToken = useSelector(({ authentication }) => authentication.token);
    const dispatch = useDispatch();

    useEffect(() => initializeUserContext({ authToken, dispatch }), [authToken, router.asPath]);

    if (!selectedCategory) return <NotFoundLayout staticContent={staticContent} />;

    return (
        <PageLayout
            staticContent={{
                ...staticContent,
                metaTags: {
                    title:
                        (router?.query?.page > 1
                            ? `Resultados página ${router.query.page} para `
                            : '') + get_(selectedCategory, ['name'], 'Catálogo'),
                    canonicalUrl:
                        router?.query?.page > 1
                            ? `${
                                  (process.env.NEXT_PUBLIC_URL + router.asPath).split(/[?#]/)[0]
                              }?page=${router.query.page}`
                            : null,
                },
            }}
            currentCategory={currentNavCategory}
        >
            <YDSCatalog
                content={selectedCategory}
                currentPage={currentPage}
                facetsKeys={facetsKeys}
            />
        </PageLayout>
    );
};

export async function getServerSideProps(context) {
    const { params, query } = context;

    if (!params.categorySlugs || !params.categorySlugs.length) return { notFound: true };

    const { reduxStore, apolloClient } = await initialize({
        withReduxStore: true,
        withApolloClient: true,
        withUserContext: true,
        context,
    });

    const menus = await getMenus(context, apolloClient);
    let currentPage = parseInt(query.page) || 1;

    /** GET FACETS LIST */
    const { data: facetsKeys } = await apolloClient.query({
        query: GET_FACETS,
        variables: {},
        fetchPolicy: 'no-cache',
    });

    /** SET CATALOG CATEGORIES MENU */
    let category = PATH_CATEGORY + '/' + params.categorySlugs[0];
    if (params.categorySlugs && params.categorySlugs.length > 1)
        category = category + '/' + params.categorySlugs[1];

    const currentNavCategory = await getCategoryContent(category, apolloClient);

    const selectedCategory = currentNavCategory ? { ...currentNavCategory } : null;
    if (query.q && selectedCategory) {
        selectedCategory.name = `Resultados para: ${query.q}`;
        selectedCategory.link = category || '';
        selectedCategory.description = '';
    }

    return {
        props: {
            initialReduxState: reduxStore.getState(),
            // initialApolloState: apolloClient.cache.extract(),
            staticContent: {
                ...menus,
                preview: !!context.preview,
            },
            selectedCategory,
            currentNavCategory,
            currentPage: currentPage,
            facetsKeys: facetsKeys,
        },
    };
}

export default Catalog;
